import React from 'react';
import PropTypes from 'prop-types';
import { VisuallyHidden } from 'core/theme';
import {
  ButtonOutlined,
  ButtonStandard,
  ButtonText,
  ButtonFAB,
  StyledIcon,
  StyledLabel
} from './styled';


class Button extends React.PureComponent {
  static defaultProps = {
    accent: 'primary',
    type: 'standard',
    typeAttr: 'button',
  };

  static propTypes = {
    a11yLabel: PropTypes.string,
    accent: PropTypes.oneOf(
      ['primary', 'secondary']
    ),
    adjustPosition: PropTypes.bool,
    icon: PropTypes.func,
    iconSize: PropTypes.oneOf(
      ['small', 'medium', 'large']
    ),
    href: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func,
    reverse: PropTypes.bool,
    type: PropTypes.oneOf(
      ['standard', 'outlined', 'text', 'fab']
    ),
    typeAttr: PropTypes.oneOf(
      ['button', 'reset', 'submit']
    ),
  };

  constructor(props, context) {
    super(props, context);
    const {children, icon, label} = props;
    if ((icon || label) && children) {
      console.warn('Button should not have children if icon or label is provided');
    }
  }

  render() {
    const {
      a11yLabel,
      accent,
      adjustPosition,
      children,
      icon: Icon,
      iconSize,
      href,
      label,
      onClick,
      reverse,
      type,
      disabled,
      typeAttr,
      ...rest,
    } = this.props;
    const {themeMode} = this.context;

    // disabled = (
    //   !href &&
    //   !onClick &&
    //   !['reset'].includes(typeAttr)
    // );

    // NOTE: Izmantojam hasIcon, nevis icon atribūtu,
    // jo icon atribūts tiek padots DOM elementam.
    const hasIcon = typeof Icon === 'function';
    const hasLabel = (label && label.length > 0) || false;

    const appearanceProps = {
      accent,
      adjustPosition,
      disabled,
      hasIcon,
      hasLabel,
      reverse,
      theme: themeMode,
    };

    let buttonIcon;
    if (hasIcon) {
      // FIXME: Nevaram izmantot definētu izmēru
      // pieejamības teksta izmēru variācijās.
      const buttonIconSize = iconSize || (label && 'small');
      buttonIcon = (
        <StyledIcon key='styled-icon' aria-hidden={true} {...appearanceProps}>
          <Icon size={buttonIconSize} />
        </StyledIcon>
      );
    }

    let buttonLabel;
    if (label) {
      buttonLabel = (
        <StyledLabel key='styled-label' {...appearanceProps}>
          {label}
        </StyledLabel>
      );
    }

    const first = reverse ? buttonIcon : buttonLabel;
    const second = reverse ? buttonLabel : buttonIcon;


    // TODO: Invert uz :hover

    let Tag;
    switch (type) {
      case 'outlined':
        Tag = ButtonOutlined;
        break;
      case 'text':
        Tag = ButtonText;
        break;
      case 'fab':
        Tag = ButtonFAB;
        break;
      default:
        Tag = ButtonStandard;
    }
    Tag = Tag.withComponent(href ? 'a' : 'button');

    return (
      <Tag
        tabIndex={disabled ? '-1' : '0'}
        {...rest}
        {...appearanceProps}
        aria-label={a11yLabel}
        href={href}
        onClick={onClick}
        type={href ? null : typeAttr}
      >
        {(first || second) ? [first, second] : children}
        {(hasIcon && !hasLabel && a11yLabel) && (
          <VisuallyHidden tabIndex='-1'>{a11yLabel}</VisuallyHidden>
        )}
      </Tag>
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/elements/Button/Button.jsx